$(() => {
	let main_slider = $('.js-main-slider .list');
	main_slider.slick({
		prevArrow: main_slider.closest('.js-main-slider').find('.controls .prev'),
		nextArrow: main_slider.closest('.js-main-slider').find('.controls .next'),
		dots: false,
		autoplay: true,
		autoplaySpeed: 2000,
	});
});